import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiClient from '@/api/axios'

export const useGeneralStore = defineStore('general', () => {
  const isLoading = ref(false)
  const packages = ref([])
  const codePromo = ref(null)
  const error = ref(null) // Ajout de error

  const fetchPackages = async (examTypeSlug, code) => {
    isLoading.value = true
    error.value = null

    try {
      let url = `/packages/${examTypeSlug ? examTypeSlug+'/':''}`
      if (code) {
        url += `?promo_code=${code}`
      }

      const response = await apiClient.get(url)
      packages.value = response.data

      return { success: true, data: response.data }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Erreur lors du chargement des packages'
      error.value = errorMessage
      return { success: false, error: errorMessage }
    } finally {
      isLoading.value = false
    }
  }

  const fetchExamType  = async () => {
    try {
      isLoading.value = true
      const response = await apiClient.get('/exam-type/')
      return response.data
    } catch (error) {
      error.value = "Erreur lors du chargement des types d'examen"
    } finally {
      isLoading.value = false
    }
  }

  const subscribe  = async (packageSlug,codePromo) => {
    try {
      isLoading.value = true
      const response = await apiClient.post('/subscription/',{slug_package:packageSlug, promo_code: codePromo})
      return response.data
    } catch (error) {
      error.value = "Erreur lors du chargement des types d'examen"
    } finally {
      isLoading.value = false
    }
  }


  return {
    // State
    isLoading,
    packages,
    codePromo,
    error,

    // Actions
    fetchPackages,
    fetchExamType,
    subscribe
  }
})
